import React from 'react';
import { BrowserRouter } from 'react-router-dom'

import AuthApp from './AuthApp'
import { Auth0Provider } from './Hooks/auth0'
import { JobSearchCriteriaProvider } from './Hooks/jobSearchCriteria';
import { OfflineProvider } from './Hooks/offline';
import { Spinner } from './Elements';
import { version } from '../package.json'
import CacheBuster from 'react-cache-buster'


const isLocal = window.location.hostname === 'localhost'

export default () => {

  React.useEffect(() => {
    const env = process.env.REACT_APP_ENV;

    //update icon
    let favicon = document.querySelector("link[rel~='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(favicon);
    }
    favicon.href = `${window.location.href}${env}favicon.ico`;

    // update apple-touch-icon
    let logo192 = document.querySelector("link[rel~='apple-touch-icon']");
    if (!logo192) {
      logo192 = document.createElement('link');
      logo192.rel = 'apple-touch-icon';
      document.getElementsByTagName('head')[0].appendChild(logo192);
    }
    logo192.href = `${window.location.href}${env}logo192.png`;
    
  }, []);

  return (
    <CacheBuster
    currentVersion={version}
    isEnabled={!isLocal}
    isVerboseMode={false}
    loadingComponent={<Spinner />}
  >
    <BrowserRouter>
      <Auth0Provider>
        <OfflineProvider>
          <JobSearchCriteriaProvider>
            <AuthApp default />
          </JobSearchCriteriaProvider>
        </OfflineProvider>
      </Auth0Provider>
    </BrowserRouter>
    </CacheBuster>
  ) 
}